import { TAGThemeProvider } from '@aspendental/shared-components-web';
import { AppContextProvider } from '@aspendental/shared-components-web/lib/context/AppContextProvider.ctx';
import { FacilityContextProvider } from '@aspendental/shared-components-web/lib/context/FacilityContextProvider.ctx';
import { FacilityContextProvider as FacilityContextProviderSSR } from '@aspendental/shared-components-web/lib/context/FacilityContextProviderSSR.ctx';
import { StyledEngineProvider } from '@mui/material';
import dynamic from 'next/dynamic';
import { CookiesProvider, useCookies } from 'react-cookie';
import { Client, Provider as QueryProvider, fetchExchange } from 'urql';
import { DynamicWrapper } from './DynamicWrapper';
import { contentfulGraphQLURL } from '@src/constants';
const ContentfulLivePreview = dynamic(() => import('@src/components/shared/providers/ContentfulLivePreview').then(mod => mod.default), {});
const queryClient = new Client({
  url: contentfulGraphQLURL,
  exchanges: [fetchExchange],
  requestPolicy: 'network-only',
  fetchOptions: () => {
    return {
      headers: {
        Authorization: `Bearer ${process.env.TAG_CONTENTFUL_ACCESS_TOKEN}`,
        'content-type': 'application/json'
      }
    };
  }
});
const previewQueryClient = new Client({
  url: contentfulGraphQLURL,
  exchanges: [fetchExchange],
  requestPolicy: 'network-only',
  fetchOptions: () => {
    return {
      headers: {
        Authorization: `Bearer ${process.env.TAG_CONTENTFUL_PREVIEW_ACCESS_TOKEN}`,
        'content-type': 'application/json'
      }
    };
  }
});
export const ContextProviders = ({
  config,
  preview,
  environment,
  user,
  children,
  onPageScheduling,
  facilityCode,
  defaultToCdn = false,
  deviceType,
  facilityContext,
  hideHeaderFacilityLocator = false,
  stateCodeFromHeaders
}) => {
  const [cookies] = useCookies(['tag-theme']);
  const brandTheme = cookies['tag-theme'] || config?.themeId || process.env.TAG_BRAND_THEME || 'aspendental';
  const brandName = brandTheme;
  const gqlClient = preview ? previewQueryClient : queryClient;
  const ssrFacilityContextProviderFeatureFlag = config?.featureFlags?.enableFacilityContextInSsr;
  return <QueryProvider value={gqlClient} data-sentry-element="QueryProvider" data-sentry-component="ContextProviders" data-sentry-source-file="ContextProviders.tsx">
			<DynamicWrapper Wrapper={ContentfulLivePreview} shouldWrap={!!preview} preview={preview} data-sentry-element="DynamicWrapper" data-sentry-source-file="ContextProviders.tsx">
				<CookiesProvider data-sentry-element="CookiesProvider" data-sentry-source-file="ContextProviders.tsx">
					<AppContextProvider config={config}
        // @ts-ignore
        theme={brandName} environment={environment} appName={process.env.APP_NAME || 'tag_dev'} appVersion={`${process.env.APP_VERSION ?? 'unknown'}(design-system:${process.env.DESIGN_SYSTEM_VERSION})`} stateCodeFromHeaders={stateCodeFromHeaders} data-sentry-element="AppContextProvider" data-sentry-source-file="ContextProviders.tsx">
						<StyledEngineProvider injectFirst data-sentry-element="StyledEngineProvider" data-sentry-source-file="ContextProviders.tsx">
							<TAGThemeProvider branding={brandName} deviceType={deviceType || 'mobile'} data-sentry-element="TAGThemeProvider" data-sentry-source-file="ContextProviders.tsx">
								{ssrFacilityContextProviderFeatureFlag ? <FacilityContextProviderSSR brand={brandName} user={user} onPageScheduling={onPageScheduling} facilityCode={facilityCode} defaultToCdn={defaultToCdn} disableFacilityFetching={hideHeaderFacilityLocator} ssrData={facilityContext}>
										{children}
									</FacilityContextProviderSSR> : <FacilityContextProvider brand={brandName} user={user} onPageScheduling={onPageScheduling} facilityCode={facilityCode} defaultToCdn={defaultToCdn}>
										{children}
									</FacilityContextProvider>}
							</TAGThemeProvider>
						</StyledEngineProvider>
					</AppContextProvider>
				</CookiesProvider>
			</DynamicWrapper>
		</QueryProvider>;
};